import Admin from '@/components/Admin/Admin';
import AdminStatistics from '@/components/Admin/Statistics/AdminStatistics.vue';
import ContractTemplate from '@/components/Admin/Contract/ContractTemplate.vue';
import ContractDetail from '@/components/Admin/Contract/ContractDetail.vue';

export default [
    {
        name: 'admin-dashboard',
        path: '/admin',
        component: Admin,
        meta: { roles: ['role_administrator'] },
        children: [
            {
                name: 'admin-statistics',
                path: '/admin-statistics',
                component: AdminStatistics,
                meta: { roles: ['role_administrator'] },
            },
            {
                name: 'admin-contract-detail',
                path: '/admin-contract-:id-detail',
                component: ContractDetail,
                meta: { openContractDropdown: true, roles: ['role_administrator'] },
            },
            {
                name: 'admin-contract-template',
                path: '/admin-contract-template',
                component: ContractTemplate,
                meta: { openContractDropdown: true, roles: ['role_administrator'] },
            },
        ],
    },
];
